<template>
  <div>
    <b-modal  @hide="hide" id="addModal" size="xl" title="Yeni Banka Hesabı Ekle" hide-footer @show="show">
      <b-form @submit="onSubmit" >
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Banka">
                  <b-form-select v-model="bank_name" :options="banks"></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Hesap Adı">
                  <b-input v-model="account_name" required></b-input>
                </b-form-group>
              </div>
            </div>
          </div>
            <div class="col-md-6">
                <b-form-group label="Yetkilendirilecek Site Seçin">
                    <v-select multiple="" label="name" :filterable="false" :options="sites"  class="form-control text-white"
                              v-model="site_id">
                        <template slot="option" slot-scope="option">
                            {{ option.site_name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.site_name }}
                            </div>
                        </template>
                    </v-select>
                </b-form-group>
            </div>

            <div class="col-md-6">
            <b-form-group label="IBAN">
              <b-input v-model="account_number" required></b-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Yatırım Grubu">
              <b-select :options="groups" v-model="group_id" required></b-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Site Seçin">
              <v-select multiple="" label="name" :filterable="false" :options="sites"  class="form-control text-white"
                        v-model="site_id">
                <template slot="option" slot-scope="option">
                  {{ option.site_name }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.site_name }}
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Minimum Yatırım">
                  <b-input v-model="min_accept" type="number" step="0.01" required></b-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Maksimum Yatırım">
                  <b-input v-model="max_accept" type="number" step="0.01" required></b-input>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Maksimum İşlem Adeti">
                  <b-input v-model="max_distinct_transfer_count" type="number" required></b-input>
                  <b-alert variant="info" show="">
                    Bu ay içerisinde farklı kişilerden {{ max_distinct_transfer_count}} adet yatırım alabilir.
                  </b-alert>
                </b-form-group>
              </div>
              <div class="col-md-6">
                  <b-form-group label="AÇIKLAMA">
                      <b-input v-model="description" type="text" ></b-input>
                  </b-form-group>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-form-group label="Filtrele (VIP HESABI)">
              <select v-model="filter" class="form-control">
                <option value=true> Açık </option>
                <option value=false> Kapalı </option>
              </select>
            </b-form-group>
          </div>
          <div class="col-md-6" v-if="filter === true || filter === 'true'">
            <b-badge variant="info"> Her isim'den sonra virgül (,) ile ayırınız </b-badge>
            <b-form-group label="Filtrelenecek kelimeler (VIP ISIM SOYISIM)">
              <b-input v-model="keys" placeholder="Ahmet Gül,Hasan Dere vs."></b-input>
            </b-form-group>
          </div>

        </div>
        <hr>
        <div class="d-flex justify-content-center" v-if="!loading">
          <b-button type="submit" variant="success" class=""> <i class="fas fa-check" /> Kaydet</b-button>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-button type="submit" variant="success" class="" disabled> <span>  <i class="fas fa-spinner fa-spin"></i></span> </b-button>
        </div>
      </b-form>
   </b-modal>
  </div>
</template>

<script>
import bankAccountsService from "@/services/bankAccountsService";
import sitesService from "@/services/sitesService";

export default {
  name: "AddBankAccount",
  data() {
    return {
        description: '',
      loading: false,
      account_name: '',
      account_number: '',
      max_accept: '',
      min_accept: '',
      max_distinct_transfer_count: 5,
      next_day: true,
      mail: false,
      email: '',
      email_password: '',
      mail_options: [
        { text: 'Kapalı', value: false },
      ],
      sites: [],
      site_id: '',
      stop_with_mail: true,
      groups: [],
      groupsList: [],
      group_id: '',
      filter: false,
      keys: '',
      banks: [
        {
          "value": "Fiba Bank A.S.",
          "text": "Fiba Bank A.S."
        },
        {
          "value": "ICBC Turkey Bank",
          "text": "ICBC Turkey Bank"
        },
          {
              "value": "Ziraat Bankasi A.S.",
              "text": "Ziraat Bankasi A.S."
          },
        {
          "value": "Vakif Katilim Bankasi A.S.",
          "text": "Vakif Katilim Bankasi A.S."
        },
        {
          "value": "Türkiye Halk Bankasi A.S.",
          "text": "Türkiye Halk Bankasi A.S."
        },
        {
          "value": "HSBC Bank A.S.",
          "text": "HSBC Bank A.S."
        },
        {
          "value": "Denizbank A.S.",
          "text": "Denizbank A.S."
        },
        {
          "value": "OdeaBank A.S.",
          "text": "OdeaBank A.S."
        },
          {
              "value": "Ziraat Katilim Bankasi A.S.",
              "text": "Ziraat Katilim Bankasi A.S."
          },
          {
          "value": "Al Baraka Türk Katilim Bankasi A.S.",
          "text": "Al Baraka Türk Katilim Bankasi A.S."
        },
        {
          "value": "Kuveyt Türk Katilim Bankasi A.S.",
          "text": "Kuveyt Türk Katilim Bankasi A.S."
        },
        {
          "value": "Türkiye Finans Katilim Bankasi A.S.",
          "text": "Türkiye Finans Katilim Bankasi A.S."
        },
        {
          "value": "Türkiye Vakiflar Bankasi T.A.O.",
          "text": "Türkiye Vakiflar Bankasi T.A.O."
        },
        {
          "value": "Akbank T.A.S.",
          "text": "Akbank T.A.S."
        },
        {
          "value": "HSBC Bank A.S.",
          "text": "HSBC Bank A.S."
        },
        {
          "value": "Türkiye Is Bankasi A.S.",
          "text": "Türkiye Is Bankasi A.S."
        },
        {
          "value": "Yapi ve Kredi Bankasi A.S.",
          "text": "Yapi ve Kredi Bankasi A.S."
        },
        {
          "value": "ING BANK",
          "text": "ING BANK"
        },
        {
          "value": "QNB Finansbank A.S.",
          "text": "QNB Finansbank A.S."
        },
        {
          "value": "Türkiye Garanti Bankasi A.S.",
          "text": "Türkiye Garanti Bankasi A.S."
        },
        {
          "value": "Türk Ekonomi Bankasi A.S.",
          "text": "Türk Ekonomi Bankasi A.S."
        },
        {
          "value": "Aktif Yatirim Bankasi A.S.",
          "text": "Aktif Yatirim Bankasi A.S."
        },
        {
          "value": "Şekerbank T.A.Ş",
          "text": "Şekerbank T.A.Ş"
        },
          {
              "value": "Anadolu Bank",
              "text": "Anadolu Bank"
          },
          {
              "value": "ENPARA",
              "text": "ENPARA"
          }
      ],
      bank_name: '',
    }
  },
  methods: {
    show() {
      this.loading = true
      this.getGroups()
      sitesService.getSitesForBankAccount({status: true})
      .then((res) => {
        this.loading = false
        if(res.state){
          this.sites = res.data
        }else{
          this.$store.dispatch('getConfirmMessage', {stop_with_mail: this.stop_with_mail, show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    },
    hide() {
      this.account_name = ''
      this.account_number = ''
      this.email = ''
      this.mail = false
      this.email_password = ''
      this.filter = false
      this.keys = ''
      this.sites = []
      this.groups = []
      this.bank_name = []
    },
    onSubmit(event) {
      event.preventDefault()
      this.loading = true
      bankAccountsService.add({
        account_name: this.account_name,
        account_number: this.account_number,
        max_accept: this.max_accept,
        min_accept: this.min_accept,
        max_distinct_transfer_count: this.max_distinct_transfer_count,
        next_day: this.next_day,
        site_id: this.site_id,
        mail: this.mail,
        email: this.email,
        email_password: this.email_password,
        stop_with_mail: this.stop_with_mail,
        group_id: this.group_id,
        filter: this.filter,
        keys: this.keys,
        bank_name: this.bank_name,
          description: this.description

      })
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Başarıyla Eklendi', message: ''})
              this.$bvModal.hide('addModal')
              this.$store.dispatch('getRefresh', true)
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    getGroups() {
      bankAccountsService.groups()
      .then((res) => {
        if(res.state && res.data.length > 0){
           res.data.map((group) => {
            this.groups.push({
              value: group.id,
              text: group.name
            })
          })

          this.groupsList = res.data
          this.group_id = res.data[0].id
        }
      })
    }
  },
  watch: {
    group_id: function () {
      let findIndex = this.groupsList.findIndex(e => e.id === this.group_id)
      this.max_accept = this.groupsList[findIndex].max_accept
      this.min_accept = this.groupsList[findIndex].min_accept
      this.max_distinct_transfer_count = this.groupsList[findIndex].max_distinct_transfer_count
    }
  },
}
</script>

<style scoped>

</style>